import { render, staticRenderFns } from "./DonationsHeatmap.vue?vue&type=template&id=23fa44ce&lang=pug&"
import script from "./DonationsHeatmap.vue?vue&type=script&lang=js&"
export * from "./DonationsHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./DonationsHeatmap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports